/* unplugin-vue-components disabled */import { render } from "./MyInfo.vue?vue&type=template&id=b3552f8c"
import script from "./MyInfo.vue?vue&type=script&lang=js"
export * from "./MyInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\IdeaProjects\\haoma517-cust\\haoma517-customer-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__